<template>
    <div class="content-page">
    <TheHeader />
<Contact
    minimized='true'
></Contact>
<TheFooter />
</div>
</template>

<script>
import Contact from '@/components/PresentPage/Contact';
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';

export default {
  name: 'ContactPage',
  components: {
    Contact,
    TheHeader,
    TheFooter
  }
};
</script>
